export function enumContains<T>(
  value: any,
  enumType: Record<string, T>): boolean {
  return Object.values(enumType).includes(value);
}
